import { useState, useEffect, useRef } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta1({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const containerRef = useRef(null);

	const [connections, setConnections] = useState([
		{ from: '', to: '' },
		{ from: '', to: '' },
		{ from: '', to: '' },
	]);
	const [btn1, setBtn1] = useState('');
	const [btn2, setBtn2] = useState('');
	const [btn3, setBtn3] = useState('');
	const [btn4, setBtn4] = useState('');
	const [concept1, setConcept1] = useState('');
	const [concept2, setConcept2] = useState('');
	const [concept3, setConcept3] = useState('');
	const [concept4, setConcept4] = useState('');

	const [selectedPalabra, setSelectedPalabra] = useState(null);
	const [selectedPal, setSelectedPal] = useState(null);

	const respuestas = [
		{ from: '¿Por qué?', to: 'Conecta con las emociones y motiva desde la importancia del propósito.' },
		{ from: '¿Cómo?', to: 'Explica procesos, recursos y tiempos para materializar el propósito.' },
		{ from: '¿Qué?', to: 'Dirige la acción y establece las medidas del éxito.' },
	];

	const handleWordClick = (id, word) => {
		let array = connections;
		setSelectedPal(id);
		switch (id) {
			case 1:
				setBtn1('btn1');
				setSelectedPalabra('btn1');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 2:
				setBtn2('btn2');
				setSelectedPalabra('btn2');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 3:
				setBtn3('btn3');
				setSelectedPalabra('btn3');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;

			default:
				break;
		}
	};
	const handleConceptClick = (id, word) => {
		let array = connections;

		switch (id) {
			case 4:
				setConcept1(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 5:
				setConcept2(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 6:
				setConcept3(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			default:
				break;
		}

		setSelectedPalabra(null);
		setSelectedPal(null);
	};

	const arraysAreEqual = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return false;
		return arr1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(arr2[index]));
	};

	const siguiente = () => {
		if (arraysAreEqual(connections, respuestas)) {
			setRespuesta('pregunta1', connections);
			sumarPuntos(1);
		} else {
			setRespuesta('pregunta1', connections);
			sumarPuntos(0);
		}
		cambiarPregunta(2);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>1.</div>Relaciona cada elemento del círculo dorado con su descripción correspondiente (al dar clic en cada elemento y la descripción que elijas, se pondrán del mismo color).
						</div>
					</Grid>
				</Grid>
			</Container>
			<div ref={containerRef} className='matching-container'>
				<div className='columns'>
					<div className='column words'>
						{/* {palabras.map((word, index) => (
							<div key={index} id={`${word}`} className={`word ${selectedPalabra === word ? colors[index % colors.length] : ''}`} onClick={() => handleWordClick(index)}>
								{word}
							</div>
						))} */}
						<div className={`word ${btn1}`} onClick={() => handleWordClick(1, '¿Por qué?')}>
							¿Por qué?
						</div>
						<div className={`word ${btn2}`} onClick={() => handleWordClick(2, '¿Cómo?')}>
							¿Cómo?
						</div>
						<div className={`word ${btn3}`} onClick={() => handleWordClick(3, '¿Qué?')}>
							¿Qué?
						</div>
					</div>
					<div className='column concepts'>
						{/* {conceptos.map((concept, index) => (
							<div key={index} id={`${concept}`} className={`concept ${selectedConcepto === concept ? colors[index % colors.length] : ''}`} onClick={() => handleConceptClick(index)}>
								{concept}
							</div>
						))} */}
						<div className={`concept ${concept1}`} onClick={() => handleConceptClick(4, 'Dirige la acción y establece las medidas del éxito.')}>
							Dirige la acción y establece las medidas del éxito.
						</div>
						<div className={`concept ${concept2}`} onClick={() => handleConceptClick(5, 'Conecta con las emociones y motiva desde la importancia del propósito.')}>
							Conecta con las emociones y motiva desde la importancia del propósito.
						</div>
						<div className={`concept ${concept3}`} onClick={() => handleConceptClick(6, 'Explica procesos, recursos y tiempos para materializar el propósito.')}>
							Explica procesos, recursos y tiempos para materializar el propósito.
						</div>
					</div>
				</div>
			</div>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
